// hooks/useTokenBalance.js
import { useState, useCallback } from 'react';
import { useChainId } from 'wagmi';
import ERC20_ABI from '../utils/abis/erc20TokenABI.json';
import { publicClients } from '../lib/wagmi';

export const useTokenBalance = () => {
    const [tokenBalance, setTokenBalance] = useState(null);
    const [tokenSymbol, setTokenSymbol] = useState(null);
    const [tokenDecimals, setTokenDecimals] = useState(null);
    const [isCheckingBalance, setIsCheckingBalance] = useState(false);
    const chainId = useChainId();

    const checkTokenBalance = useCallback(
        async (tokenAddress, userAddress) => {

            // console.log(tokenAddress, userAddress, "hello")
            if (!chainId || !tokenAddress || !userAddress) {
                return { balance: null, symbol: null, decimals: null };
            }

            try {
                setIsCheckingBalance(true);
                const [balance, symbol, decimals] = await Promise.all([
                    publicClients[chainId].readContract({
                        address: tokenAddress,
                        abi: ERC20_ABI,
                        functionName: "balanceOf",
                        args: [userAddress],
                    }),
                    publicClients[chainId].readContract({
                        address: tokenAddress,
                        abi: ERC20_ABI,
                        functionName: "symbol",
                    }),
                    publicClients[chainId].readContract({
                        address: tokenAddress,
                        abi: ERC20_ABI,
                        functionName: "decimals",
                    }),
                ]);

                // console.log(symbol, "Symbol", decimals, "Decimals")
                setTokenBalance(balance);
                setTokenSymbol(symbol);
                setTokenDecimals(decimals);
                return { balance, symbol, decimals };
            } catch (error) {
                console.error("Error getting balance, symbol, or decimals:", error);
                setTokenBalance(null);
                setTokenSymbol(null);
                setTokenDecimals(null);
                return { balance: null, symbol: null, decimals: null };
            } finally {
                setIsCheckingBalance(false);
            }
        },
        [chainId]
    );

    return {
        tokenBalance,
        tokenSymbol,
        tokenDecimals,
        isCheckingBalance,
        checkTokenBalance
    };
};